export const businessOrInvoiceContentSectionsPart1 = [
  {
    titleKey: 'START_YOUR_OWN_BUSINESS_OR_INVOZIO',
    textKeys: ['START_YOUR_OWN_BUSINESS_OR_INVOZIO_TEXT_1', 'START_YOUR_OWN_BUSINESS_OR_INVOZIO_TEXT_2']
  }
];

export const businessOrInvoiceContentSectionsPart2 = [
  {
    titleKey: 'AVOID_ALL_ADMINISTRATION_AND_INVOICING',
    textKeys: ['AVOID_ALL_ADMINISTRATION_AND_INVOICING_TEXT']
  },
  {
    titleKey: 'WITH_INVOZIO_YOU_CAN',
    textKeys: ['WITH_INVOZIO_DESCRIPTION']
  },
];

export const businessOrInvoiceContentSectionsPart3 = [
  {
    titleKey: 'INVOICING_WITHOUT_COMPANY_FOR_FREELANCERS',
    textKeys: ['INVOICING_WITHOUT_COMPANY_FOR_FREELANCERS_TEXT']
  }
];

export const businessOrInvoiceContentSectionsPart4 = [
  {
    titleKey: 'CAN_I_AS_INDIVIDUAL_INVOICE_WITHOUT_COMPANY',
    textKeys: ['CAN_I_AS_INDIVIDUAL_INVOICE_WITHOUT_COMPANY_TEXT']
  }
];

export const businessOrInvoiceContentSectionsPart5 = [
  {
    titleKey: 'HOW_DOES_INVOICE_WITHOUT_COMPANY_WORK',
    textKeys: ['HOW_DOES_INVOICE_WITHOUT_COMPANY_WORK_TEXT']
  }
];

export const businessOrInvoiceContentSectionsPart6 = [
  {
    titleKey: 'HOW_MUCH_SALARY_DO_I_RECEIVE_FOR_INVOICE',
    textKeys: ['HOW_MUCH_SALARY_DO_I_RECEIVE_FOR_INVOICE_TEXT']
  }
];

export const businessOrInvoiceContentSectionsPart7 = [
  {
    titleKey: 'CANT_I_JUST_INVOICE_AS_INDIVIDUAL',
    textKeys: ['CANT_I_JUST_INVOICE_AS_INDIVIDUAL_TEXT']
  }
];

export const businessOrInvoiceContentSectionsPart8 = [
  {
    titleKey: 'WHAT_APPLIES_WHEN_INVOICING_WITH_HOBBY_BUSINESS',
    textKeys: ['WHAT_APPLIES_WHEN_INVOICING_WITH_HOBBY_BUSINESS_TEXT']
  },
  {
    titleKey: 'SKIP_INVOICING_FINANCE_ADMINISTRATION_BOOKKEEPING',
    textKeys: ['SKIP_INVOICING_FINANCE_ADMINISTRATION_BOOKKEEPING_TEXT']
  },
  {
    titleKey: 'SENDING_INVOICE_AS_PRIVATE_INDIVIDUAL_WITHOUT_F_TAX',
    textKeys: ['SENDING_INVOICE_AS_PRIVATE_INDIVIDUAL_WITHOUT_F_TAX_TEXT']
  }
];

export const businessOrInvoiceContentSectionsPart9 = [
  {
    titleKey: 'DESIGNED_SERVICE_FOR_INVOICING_WITHOUT_COMPANY',
    textKeys: ['DESIGNED_SERVICE_FOR_INVOICING_WITHOUT_COMPANY_TEXT_1', 'DESIGNED_SERVICE_FOR_INVOICING_WITHOUT_COMPANY_TEXT_2']
  }
];
